import { Observable } from 'rxjs/Observable';

export class DashboardUtils {
  static totalAsStringClampedTo99(totalObs: Observable<number>): Observable<string> {
    return totalObs.map(total => total >= 99 ? '99+' : String(total));
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/dashboard-util.ts